module.exports = __webpack_public_path__ + "img/icon-portfolio.c5ffd6cd.svg";